/** Igualdade profunda para dados JSON do domínio (objetos, listas e primitivos). */
export function isDeepStrictEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;

  const ka = Object.keys(a);
  const kb = Object.keys(b);

  if (ka.length !== kb.length) return false;

  return ka.every(
    (key) =>
      Object.prototype.hasOwnProperty.call(b, key) &&
      isDeepStrictEqual((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key])
  );
}
